import React from 'react';
import { Table } from 'react-bootstrap';
import PropTypes from 'prop-types';

import SortContainer from './Sort/Container';

const SignupTable = ({ isLoading, access, items, handleSort, onEdit }) => {
  const handleSortEnd = ({ oldIndex, newIndex }) => {
    if (!access?.payments_sort) return;
    if (oldIndex !== newIndex) {
      handleSort({ oldIndex, newIndex });
    }
  };

  const handleSortStart = ({ node }, event) => {
    event.preventDefault();
    const tds = document.getElementsByClassName('on-drag')?.[0]?.childNodes;
    node?.childNodes?.forEach((node, idx) => (tds[idx].style.width = `${node.offsetWidth}px`));
  };

  return (
    <Table>
      <colgroup>
        <col span="1" style={{ width: '75%' }} />
        <col span="1" style={{ width: '10%' }} />
        <col span="1" style={{ width: '10%' }} />
      </colgroup>
      <SortContainer
        helperClass="on-drag"
        isLoading={isLoading}
        items={items}
        access={access}
        onSortStart={handleSortStart}
        onSortEnd={handleSortEnd}
        onEdit={onEdit}
        useDragHandle={access?.signup_sort}
      />
    </Table>
  );
};

SignupTable.propTypes = {
  isLoading: PropTypes.bool,
  access: PropTypes.object,
  items: PropTypes.array,
  handleSort: PropTypes.func,
  onEdit: PropTypes.func,
};

export default SignupTable;
